import { Button, Title } from 'aimo-ui';
import AddPaymentMethod from 'components/payment/AddPaymentMethod';
import useOnboardingRedirect from 'hooks/useOnboardingRedirect';
import { useVerifyWalletToken } from 'hooks/useVerifyWalletToken';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useActiveElementStore } from 'stores/activeElementStore';
import styled from 'styled-components/native';
import { StyledImage, StyledWrapper } from 'styles/ContainerStyles';
import { FooterWrapper, MainWrapper } from 'styles/ModalStackContainerStyles';
import { PaymentDataProps } from 'types/PaymentData';
import { testIdentifiers } from 'utils/testIdentifiers';

const PictureContainer = styled.View`
  width: 100%;
  padding: 80px 0 90px;
`;

// AddPaymentMethod inserts the addable wallet rows after the card row and
// hides MobilePay when the user is not eligible.
const paymentData: PaymentDataProps[] = [
  {
    title: 'payment.creditCard',
    icon: 'Credit_Card-Outlined',
    action: 'addCardOnboarding',
    testID: 'add-payment-card-button',
    iconRight: 'Chevron_Right',
  },
  {
    title: 'paymentMethods.mobilePay',
    icon: 'Mobile-Pay',
    action: 'addMobilePay',
    testID: 'add-mobilepay-button',
    iconRight: 'Chevron_Right',
  },
];

const OnBoardingAddPaymentMethod: React.FC = () => {
  const parkingZoneUid = useActiveElementStore((state) => state.activeElement);
  const { t } = useTranslation();
  const { handleSuccessNavigationAfterAddCardDetails } =
    useOnboardingRedirect();
  useVerifyWalletToken();

  return (
    <MainWrapper vAlignCenter={true}>
      <View>
        <PictureContainer>
          <StyledImage
            testID="onboarding-payment-method-image"
            width={123}
            height={102}
            center
            source={require('assets/images/onboarding-payment-method.png')}
          />
        </PictureContainer>
        <StyledWrapper center mb={30}>
          <Title center testID="onboarding-payment-method-title">
            {t('onboarding.addPaymentMethod')}
          </Title>
        </StyledWrapper>
        <AddPaymentMethod paymentData={paymentData} isOnboarding />
      </View>
      {parkingZoneUid === '' && (
        <FooterWrapper>
          <Button
            {...testIdentifiers('skip-button')}
            text={t('onboarding.skipForNow')}
            size="l"
            buttonType="link"
            onPress={handleSuccessNavigationAfterAddCardDetails}
          />
        </FooterWrapper>
      )}
    </MainWrapper>
  );
};

export default OnBoardingAddPaymentMethod;
